import { render } from "./ItemRewardSelect.vue?vue&type=template&id=0260adae"
import script from "./ItemRewardSelect.vue?vue&type=script&lang=ts"
export * from "./ItemRewardSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script